// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ExternalNetworkDiscoverySourceTypeSchema = z.enum(['USER_PROVIDED','CLOUD_INVENTORY','ACTIVE_SCAN','REVERSE_DNS','SERVICE_DETECTION'] as const);

export type ExternalNetworkDiscoverySourceTypeType = `${z.infer<typeof ExternalNetworkDiscoverySourceTypeSchema>}`

export default ExternalNetworkDiscoverySourceTypeSchema;
